import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { IDeleteConfirmationModalProps } from './IDeleteConfirmationModalProps';
import { IDeleteConfirmationModalState } from './IDeleteConfirmationModalState';
import styles from './DeleteConfirmationModal.module.scss';
import classNames from 'classnames';
import IconButton from "../../../../../common/buttons/icon-button/IconButton";

export default class DeleteConfirmationModal extends Component<IDeleteConfirmationModalProps, IDeleteConfirmationModalState> {

  private static removeDialogIndex = 100;

  constructor(props: IDeleteConfirmationModalProps) {
    super(props);

    this.state = {
      dialogId: 'remove_line_dialog_' + (DeleteConfirmationModal.removeDialogIndex++)
    };

    this.onConfirmClicked = this.onConfirmClicked.bind(this);
  }

  render() {
    return (
      <ReactModal
        appElement={document.getElementById('root') as HTMLElement}
        isOpen={this.props.showDialog}
        id={this.state.dialogId}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        className={classNames([styles.dialog, "shadow p-4"])}
      >
        <h2>Delete project info line</h2>

        <p>Are you sure you want to delete <b className={"text-break"}>{this.props.lineNameToRemove}</b>?</p>

        <div className="d-flex justify-content-end">
          <IconButton onClick={this.onConfirmClicked} variant="outline-primary" title="Delete" styles={{marginRight: '1em'}}/>
          <IconButton onClick={this.props.onCancel} variant="outline-primary" title="Cancel"/>
        </div>
      </ReactModal>
    );
  }

  onConfirmClicked() {
    if (this.props.onConfirm !== undefined && this.props.onConfirm !== null) {
      this.props.onConfirm(this.props.lineIdToRemove ?? 0);
    }
  }
}
